const formatError = (error, defaultMessage = "") => {
  let res = error?.response?.data?.message || error?.response?.message || error?.message || defaultMessage;

  return res;
};

export default formatError;
